/*
    Page carrière
 */
$(function() {
    $('#impact-carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '#impact-carousel-container',
        prevArrow: '<div class="col-xs-1"><button type="button" title="Précédent" class="slick-prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></button></div>',
        nextArrow: '<div class="col-xs-1"><button type="button" title="Suivant" class="slick-next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></button></div>',
    });

    $('#bienveillance-carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '#bienveillance-carousel-container',
        prevArrow: '<div class="col-xs-1"><button type="button" title="Précédent" class="slick-prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></button></div>',
        nextArrow: '<div class="col-xs-1"><button type="button" title="Suivant" class="slick-next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></button></div>',
    });

    $('#transformation-carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '#transformation-carousel-container',
        prevArrow: '<div class="col-xs-1"><button type="button" title="Précédent" class="slick-prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></button></div>',
        nextArrow: '<div class="col-xs-1"><button type="button" title="Suivant" class="slick-next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></button></div>',
    });
    if ($('.video-thumbnails').length) {
        $('a.video-changer').parent().off('click').on('click', function(e) {
            const $vid = $(this).find('a.video-changer');
            e.preventDefault()

            //change video
            const target = $vid.data('target');
            $('#' + target).attr('src', $vid.data('src'));

            //change title
            const title = $vid.children().attr('title')
            $('#' + target + "-title").text(title);

            //scroll to main video
            $('html, body').animate({
                scrollTop: $("#main-player-video").offset().top -20
            }, 500);
        })
    }
});

// video and modal with video
$(function(){
  $('#intro-video-bg').YTPlayer({
    // useNoCookie: true,

    showYTLogo: false,
    useOnMobile: true
  })
  // $("#intro-video-bg").vimeo_player();
  // $("#intro-video-bg").on("VPTime",function(e){
  //   if (e.time >= 1.5) {
  //     if (!$("#intro-video-bg").hasClass('loaded')) {
  //       $("#intro-video-bg").addClass('loaded');
  //     }
  //   }
  // });
  const iframe = document.querySelector( '#carriere-overlay-player iframe');
  let iframeSrc = null;
  if (iframe) {
    iframeSrc = iframe.getAttribute('src');

  }

  $(".play-wrapper").on('click', function(e){
    $('.modal').addClass('visible');
    if (iframe && iframeSrc) {
      iframe.setAttribute('src', iframeSrc);
    }
  });

  $(".video-modal-close").on('click', function(e){
    $('.modal').removeClass('visible');
    // pause the vimeo iframe
    if (iframe && iframeSrc) {
      iframe.setAttribute('src', '');
    }
  });

  $(".modal").on('click', function(e){
    $('.modal').removeClass('visible');
    if (iframe && iframeSrc) {
      iframe.setAttribute('src', '');
    }
  });
});
